import { Controller } from "@hotwired/stimulus"

// Native <dialog> helper: click backdrop or press Escape to close (with showModal).
export default class extends Controller {
  connect() {
    this.onBackdropClick = this.onBackdropClick.bind(this)
    this.element.addEventListener("click", this.onBackdropClick)
  }

  disconnect() {
    this.element.removeEventListener("click", this.onBackdropClick)
  }

  onBackdropClick(event) {
    if (event.target === this.element) {
      this.element.close()
    }
  }

  close() {
    this.element.close()
  }
}
